<div class="card__section" *ngIf="records.length > 0">
  <div class="row">
    <div class="columns">
      <h3 class="typography--subheader">Validation Results</h3>
      <p class="typography--caption" *ngIf="errors.length > 0">
        <span class="label label--alert">{{ errors.length }} validation error(s) found. Hover over highlighted cells to see error details.</span>
      </p>
      <p class="typography--caption" *ngIf="errors.length === 0 && changes.length > 0">
        <span class="label label--success">No validation errors found. You can proceed with upload.</span>
      </p>
      <p class="typography--caption" *ngIf="changes.length === 0">
        <span class="label label--warning-lite">Data is already up-to-date with existing records. No changes found.</span>
      </p>
      <p class="typography--caption" *ngIf="changes.length > 0">
        <span class="label label--info" style="margin-left: 0;">{{ changes.length }} field(s) changed. Hover over highlighted cells to see change details.</span>
      </p>
    </div>
  </div>
  <div class="table" role="table">
    <span role="rowgroup">
      <span class="table__row table__row--header" role="row">
        <span class="table__cell table__cell--half" role="columnheader">#</span>
        <span class="table__cell table__cell--one" role="columnheader" *ngFor="let field of fields">
          {{ field.label }}
        </span>
        <span class="table__cell table__cell--one" role="columnheader">Action</span>
      </span>
    </span>
    <div role="rowgroup">
      <span
        class="table__row"
        role="row"
        *ngFor="let record of pagedRecords; let i = index"
        [class.has-error]="hasRowErrors(record.rowIndex)"
      >
        <span class="table__cell table__cell--half" role="cell">{{ (currentPage - 1) * pageSize + i + 1 }}</span>
        <span
          class="table__cell table__cell--one"
          role="cell"
          *ngFor="let field of fields"
          [class.cell-error]="hasError(record.rowIndex, field.key)"
          [title]="getCellTitle(record.rowIndex, field.key)"
          [class.cell-changed]="isChanged(record.rowIndex, field.key)"
        >
          {{ getFieldValue(record, field.key) }}
        </span>
        <span class="table__cell table__cell--one" role="cell">
          <span class="label" [class.label--success-lite]="getActionLabel(record) === 'Create'" [class.label--info-lite]="getActionLabel(record) === 'Update'" [class.label--warning-lite]="getActionLabel(record) === 'No Change'">
            {{ getActionLabel(record) }}
          </span>
        </span>
      </span>
    </div>
  </div>

  <!-- Pagination -->
  <generic-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="records.length"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  ></generic-pagination>

  <!-- Validation Errors List Table -->
  <generic-validation-errors-table
    [errors]="errors"
  ></generic-validation-errors-table>
</div>